module.exports = __webpack_public_path__ + "static/media/helpcard3.59c3da67.svg";